import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { CommonMethodService } from '../../common/commonMethod.service';
import { ChangePasswordModel } from '../../models/changePassword.model';

@Component({
  selector: 'app-reset-password',
  templateUrl: 'resetPassword.component.html',
  providers: [UserService, CommonMethodService]
})
export class ResetPasswordComponent implements OnInit , OnDestroy {

  subscribe: Array<Subscription> = [];
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  loader: boolean = false;
  token: string;
  username: string;

  constructor(private route: Router, private userService: UserService, private acticeRoute: ActivatedRoute,
    private toaster: ToastrService, private commonMethodService: CommonMethodService) {
      this.acticeRoute.params.subscribe(
        params => {
          this.token = params['token'];
          this.username = params['username'];
        });
  }

  ngOnInit(): void {
    this.checkResetLinkExpire();
  }

  checkResetLinkExpire(): void {
    const details =  new ChangePasswordModel();
    if (this.token === null || this.token === undefined || this.token === '' || this.token.trim() === '') {
      return;
    }
    if (this.username === null || this.username === undefined || this.username === '' || this.username.trim() === '') {
      return;
    }
    details.token = this.token;
    details.username = this.username;
    this.loader = true;
    this.subscribe.push(this.userService.checkResetLinkExpire(details).subscribe(
      data => {
        this.loader = false;
      }, error => {
        this.loader = false;
        this.route.navigate(['/']);
        this.commonMethodService.returnErrorMessage(error);
      }));

  }

  onSubmit(): void {
    if (this.newPassword === undefined || this.newPassword === '') {
      this.toaster.error('Please enter new password');
      return;
    }
     if (this.newPassword.indexOf(' ') !== -1 ) {
      this.toaster.error('Space not allowed in new password');
      return;
    }
    if (this.confirmPassword === undefined || this.confirmPassword === '') {
      this.toaster.error('Please enter confirm password');
      return;
    }
    if (this.newPassword !== this.confirmPassword ) {
      this.toaster.error('New password and confirm password do not match');
      return;
    }
    const details =  new ChangePasswordModel();
    if (this.token === undefined || this.token === '') {
      return;
    }
    if (this.username === undefined || this.username === '') {
      return;
    }
    details.newPassword = this.newPassword;
    details.token = this.token;
    details.username = this.username;
    this.loader = true;
    this.subscribe.push(this.userService.resetPasswordChange(details).subscribe(
      data => {
        this.toaster.success('Password successfully changed.');
        sessionStorage.clear();
        this.loader = false;
        this.route.navigate(['/']);
      }, error => {
        this.loader = false;
        this.commonMethodService.returnErrorMessage(error);
      }));

  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

}
